import * as yup from "yup";

export const loginSchema = yup.object().shape({
  username: yup
    .string()
    .required("Enter a valid username"),
  password: yup
    .string()
    .required("Password is required"),
  remember: yup.boolean(),
});
